
import * as React from "react";
import {Tooltip,TooltipProps} from '@material-ui/core'

export default function CustomTooltip(props:TooltipProps) {
    
    return <Tooltip {...props}/>;
  }